import LinesEllipsis from 'react-lines-ellipsis';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import colors from 'shared-assets/lib/colors';

const SeeMore = styled.button`
  background: transparent;
  border: none;
  font-size: 1rem;
  color: ${colors.primary};
  cursor: pointer;
`;

class ReadMore extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      truncateMessage: props.truncateMessage,
    };
  }

  handleSeeMoreMessage = () => {
    this.setState({
      truncateMessage: false,
    });
  };

  render() {
    return (
      <Fragment>
        <If condition={this.state.truncateMessage}>
          <LinesEllipsis
            text={this.props.children}
            maxLine={this.props.maxLine}
            ellipsis={
              <span onClick={this.handleSeeMoreMessage}>
                {this.props.ellipsis}
              </span>
            }
            trimRight={this.props.trimRight}
            basedOn={this.props.basedOn}
          />
        </If>
        <If condition={!this.state.truncateMessage}>{this.props.children}</If>
      </Fragment>
    );
  }
}

ReadMore.defaultProps = {
  basedOn: 'letters',
  children: undefined,
  ellipsis: (
    <Fragment>
      ...
      <SeeMore>See More</SeeMore>
    </Fragment>
  ),
  maxLine: 2,
  style: {},
  trimRight: true,
  truncateMessage: false,
};

ReadMore.propTypes = {
  basedOn: PropTypes.oneOf(['letters', 'words']),
  children: PropTypes.node,
  ellipsis: PropTypes.node,
  maxLine: PropTypes.number,
  style: PropTypes.object,
  trimRight: PropTypes.bool,
  truncateMessage: PropTypes.bool,
};

export default ReadMore;
